import { setProperties } from '@ember/object'

export enum SortIcon {
  Ascending = 'phosphor-caret-up-fill',
  Descending = 'phosphor-caret-down-fill',
  Default = 'phosphor-caret-up-down-fill',
}

/**
 * This helper toggles the sort icon on a sortable table
 *
 * Example usage in a template
 * <th role="button"
 *     {{action "statefulSort" tableAction "sortByValue || sortByNumber || sortByDate ||  sortByGrade || sort" "columnName"}}
 * >
 *   Column Name
 *   <PhosphorIcon @icon={{if (eq currentSortColumn "columnName") currentSortIcon "phosphor-caret-up-down-fill"}} />
 * </th>
 */

export function statefulSort(
  this: {
    currentSortColumn: Nullable<string>
    currentSortIcon: SortIcon
  },
  tableAction: (tableActionOperation: string, tableActionKey: string) => unknown,
  tableActionOperation: string,
  tableActionKey: string,
) {
  tableAction(tableActionOperation, tableActionKey)

  let newSortIcon = SortIcon.Ascending // default sort direction 'asc'

  // If the column has already been sorted, toggle the direction
  if (this.currentSortColumn === tableActionKey) {
    if (this.currentSortIcon === SortIcon.Ascending) {
      newSortIcon = SortIcon.Descending // sort direction 'desc'
    } else {
      newSortIcon = SortIcon.Ascending // sort direction 'asc'
    }
  }

  setProperties(this, {
    currentSortColumn: tableActionKey,
    currentSortIcon: newSortIcon,
  })
}
